// extracted by mini-css-extract-plugin
export default {"paymentDays":"supplierForm_paymentDays__cHI4d"};